module.exports = __webpack_public_path__ + "static/media/QC_Inspection_Template_1.8c83fd0a.png";